import React, { useState, useEffect } from 'react';
import ContainerLoaderCharts from '../logistica/Charts/ContainerLoaderCharts';
import stilePulsanti from '../interfaccia/stilePulsanti';
import SettingBooleano from './SettingBooleano';

function StatSpedCorrieri({
  mobile
}) {
  
    const {
        buttonClassesWhite,
        buttonClassesGreen
    } = stilePulsanti

    const colors = {
        brt: "#FF4136",
        gls: "#0e1e6e",
        dhl: "#FFB700",
        ups: "#5C3419",
        others: "grey"
    };

    const [settings, setSettings] = useState({
        series: {
            brt: true,
            dhl: true,
            gls: true,
            ups: true,
            others: true
        },        
        anni: 3,
        spedServizio: 1
    })



  return (
    
        <div className='sfondoBiancoTema tc pa3 '>
        <h3>Ordini per corriere all-time</h3>
            <div className='flex items-center justify-center'>
                <div>ultimi</div>
            <input
                type='number'
                value={settings.anni}
                onChange={(e)=>setSettings({...settings,anni:e.target.value})}
                className={stilePulsanti.inputClassesRicercaOrizzontale}
                min={1}
                max={10}
            />
            <div className='mr4'>anni</div>
            {["brt", "gls", "dhl", "ups", "others"].map((key) => {
                const labelMap = {
                    brt: "BRT",
                    gls: "GLS",
                    dhl: "DHL",
                    ups: "UPS",
                    others: "ALTRI",
                };
                const attivo = settings.series[key];
                const colore = colors[key] || "#ccc";
                return (
                    <button
                        key={key}
                        onClick={() =>
                            setSettings({
                                ...settings,
                                series: { ...settings.series, [key]: !attivo },
                            })
                        }
                        className="ma1 pa2 pointer br2 f6 b--none"
                        style={{
                            backgroundColor: attivo ? colore : "#f5f5f5",
                            color: attivo ? "#fff" : "#333",
                            border: attivo ? "none" : "1px solid #ccc",
                            minWidth: "4rem",
                        }}
                    >
                        {labelMap[key]}
                    </button>
                );
            })}
            <div className='ml4 mr3'>considera spedizioni di servizio</div>
            <SettingBooleano 
                value={settings.spedServizio}
                    trueButtonClass={buttonClassesGreen}
                    falseButtonClass={buttonClassesWhite}
                    trueElement={"SI"}
                    falseElement={"NO"}
                    setTrue={()=>setSettings({...settings,spedServizio:1})}
                    setFalse={()=>setSettings({...settings,spedServizio:0})}
            />
            </div>            
            <ContainerLoaderCharts 
                query={`/contab/charts/linesSpedizioniCorrieri?`+ new URLSearchParams({anni: settings.anni, spedServizio: settings.spedServizio})}
                titolo="Importo per corriere all-time"
                tipo ="linesSpedizioniCorrieri"
                displayTitolo={false}
                settings={settings}
            />
        </div>
  )
}

export default StatSpedCorrieri;
